import { ProgramSlideItem } from "./slides/ProgramSlideItem/ProgramSlideItem";
import { WorkoutSlideItem } from "./slides/WorkoutSlideItem/WorkoutSlideItem";
import { HOMEPAGE_SECTIONS_TYPE } from "../../../../../groups/app/Fitness/constants";

export const CAROUSEL_ITEM_COMPONENTS_BY_SECTION_TYPE = {
    [HOMEPAGE_SECTIONS_TYPE.PROGRAM]: ProgramSlideItem,
    [HOMEPAGE_SECTIONS_TYPE.WORKOUT]: WorkoutSlideItem
}